/* eslint-disable no-bitwise */
// utils.js

// Extracts up to two initials from a full name
export const getInitials = (name) => {
  if (!name) return '';
  const parts = name.trim().split(/\s+/);
  const initials = parts.map((part) => part.charAt(0).toUpperCase());

  if (initials.length > 1) {
    return `${initials[0]}${initials[initials.length - 1]}`;
  }
  return initials[0] || '';
};

// Generates a deterministic HSL color based on the name string
export const stringToColor = (string) => {
  if (!string) return '#ccc';
  let hash = 0;
  for (let i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }
  // Use HSL to ensure the color is vibrant and has good contrast
  const hue = Math.abs(hash) % 360;
  return `hsl(${hue}, 65%, 45%)`; // 45% lightness provides safe contrast for white text
};
